import { FilterValue } from '@src/design-system/filter-new';
import type { TRenderSelectedValuesCtx } from '../../types/filter-config';
import { calendlyTypeApi } from '@src/features/settings/pages/integration/services/get-calendly-types';
import { formatTextForDisplay } from '@src/shared/utils/helpers/format-text-for-display';
import { entityFilterIds } from '../../helpers/filter-none';

const SingleValue = ({ id }: { id: string | number }) => {
  const isValueStr = isNaN(+id);

  const { data: status } = calendlyTypeApi.useFetchOne(
    { id },
    { enabled: !!id && !isValueStr }
  );

  return (
    <FilterValue>
      {formatTextForDisplay(isValueStr ? String(id) : String(status?.name))}
    </FilterValue>
  );
};

export function LeadCalendlyTypeFilterSelectedValues({
  filter,
}: TRenderSelectedValuesCtx) {
  return entityFilterIds(filter.value).map((v) => (
    <SingleValue
      key={v}
      id={v}
    />
  ));
}
